/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import {KTSVG} from '../../../helpers'

type Props = {
  className: string
  color?: string
  svgIcon: string
  iconColor: string
  title: string
  description: string
}

const StatisticsWidget5: React.FC<Props> = ({
  className,
  color,
  svgIcon,
  iconColor,
  title,
  description,
}) => {
  return (
    <a style={{ height: 120 }} href='#' className={`card bg-${color} box-hover-shadow p-2 hoverable ${className}`}>
      {/* begin::Body */}
      <div className='card-body'>
        <div className={'flex justify-space flex-row-reverse items-center'}>
          <KTSVG path={svgIcon} className={`svg-icon-${iconColor} svg-icon-3x ml-5  flex justify-end ms-n1`} />
          <div className={`text-inverse-${color} fw-bolder flex justify-end fs-2 ir-black mr-5 mb-2 text-white`}>{title}</div>
        </div>
        <div className={`fw-bold flex mt-2 w-full justify-end text-inverse-${color} text-white fs-7`}>{description}</div>
      </div>
      {/* end::Body */}
    </a>
  )
}

export {StatisticsWidget5}
